<script>
  export let type = "primary";
  export let flat = false;
  export let inverse = false;
</script>

<button class="{type} unselectable" class:flat class:inverse on:click>
  <span><slot /></span>
</button>

<style>
  button {
    border: 0;
    cursor: pointer;
    border-radius: 6px;
    padding: 8px 12px;
    font-weight: 500;
    text-align: center;
    box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.2);
    transition: all 0.25s;
  }
  button span {
    display: inline-block;
    position: relative;
    transition: 0.25s;
  }
  button span:after {
    content: "\00bb";
    font-size: 1.5rem;
    position: absolute;
    opacity: 0;
    top: -9px;
    right: -12px;
    transition: 0.25s;
  }
  button:hover span {
    padding-right: 25px;
  }

  button:hover span:after {
    opacity: 1;
    right: 0;
  }
  .primary {
    background: #1a91bc;
    color: white;
  }
  .secondary {
    background: #f1b6e8;
    color: white;
  }
  .flat {
    box-shadow: none;
  }
  .primary.inverse {
    color: #1a91bc;
    background: white;
    border: 2px solid #1a91bc;
  }
  .secondary.inverse {
    color: #f1b6e8;
    background: white;
    border: 2px solid #f1b6e8;
  }
  .primary:not(:disabled):active,
  .secondary:not(:disabled):active {
    background: #ddd;
  }
  .primary.inverse:not(:disabled):active,
  .secondary.inverse:not(:disabled):active {
    background: white;
    color: #ddd;
    border: 2px solid #ddd;
  }
</style>
